import { accountKeys } from '@taler/api-client'
import type { Locale } from '@taler/domain'
import { useQuery } from '@tanstack/vue-query'
import { computed, type ComputedRef } from 'vue'
import { useApi } from '@/app/api'
import { buildAccountLookup, type AccountLookup } from '../internal/account-index.ts'

/** The accounts tree, flattened to an id-keyed lookup - a reconciliation row carries only
 * an accountId and its figures, never a name, icon or class. */
export function useAccountLookup(options: {
  readonly ledgerId: () => string | undefined
  readonly locale: () => Locale
  readonly enabled: () => boolean
}): ComputedRef<ReadonlyMap<string, AccountLookup>> {
  const api = useApi()
  const active = computed(() => options.enabled() && options.ledgerId() !== undefined)

  const query = useQuery({
    queryKey: computed(() => accountKeys.tree(options.ledgerId() ?? '')),
    queryFn: ({ signal }) => api.accounts.tree(options.ledgerId()!, signal),
    enabled: active,
    retry: false,
  })

  return computed(() => buildAccountLookup(query.data.value ?? [], options.locale()))
}
